// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Collapsible from './../../components/Collapsible';

import RenderParentBody from './RenderParentBody';

import Styles from './styles.module.scss';

interface Data{
    name: string;
    sku: string;
    serialNumber: string;
}

interface PropsType {
    data: Data[];
    selected: Data[];
    onSelect: (selected: Data[]) => void;
}

export default function ParentListItem(props: PropsType): JSX.Element {
    const { t } = useTranslation();
    return (
        <Collapsible
            isOpen={true}
            colorOnOpen={'white'}
            colorOnClose={'nobel'}
            chevronColor={'black'}
            header={HeaderRender()}
            tableName={t('device')}
        >
            <div className={Styles.body}>
                {RenderParentBody({
                    data: props.data,
                    selected: props.selected,
                    onSelect: props.onSelect,
                })}
            </div>
        </Collapsible>
    );
}

function HeaderRender(): JSX.Element {
    const { t } = useTranslation();

    return (
        <div className={Styles.header}>
            <div className={Styles.headerText}>
                {t('device')}
            </div>
        </div>
    );
}
